import React, { useEffect } from 'react';
import Modal from 'react-modal';
import CloseButton from '../buttons/CloseButton';
import {IThriveModal} from '../../../interfaces/modals/modal';



const ThriveModal = ({showModal, className, headerContent, bodyContent, footerContent, onCloseClick, isFullPageModal, canEscapeClose, parentSelector}: IThriveModal) => {    
    const autoClose = () => {
        if(canEscapeClose){
            onCloseClick();
        }
    }

    useEffect(() =>  {
        if (showModal) {            
            document.body.style.overflowY = "hidden"
        } else {
            document.body.style.overflowY = "initial"
        }

        return () => { 
            document.body.style.overflowY = "initial";
        }
    }, [showModal])

    return (

        <Modal
            style={{overlay: {zIndex: 50}}}
            closeTimeoutMS={200}                  
            isOpen={showModal}
            parentSelector={parentSelector ?? undefined}
            contentLabel=""
            className={`thrive-modal thrive-basic-modal-wrapper ${className ?? ""}`}
            overlayClassName={`thrive-modal-overlay ${isFullPageModal ? 'fullpage-modal' : ''}`}
            onRequestClose={() => {autoClose()}}
            ariaHideApp={false}
            aria={{
                labelledby: "thrive-modal-labelled-by",
            }}
        >
            <span id={"thrive-modal-labelled-by"} className={`thrive-basic-modal-header`}>
                {headerContent ?? <span className="blank" />}
                <CloseButton onButtonClick={onCloseClick} ariaLabel={'Close Modal'}/>
            </span>

            <span className={`thrive-basic-modal-body`}>
                {bodyContent ?? <></>}
            </span>

            <span className={`thrive-basic-modal-footer`}>
                {footerContent ?? <></>}
            </span>
        </Modal>
    );  
};

export default ThriveModal;